const userAgent = window.navigator.userAgent.toLowerCase();

export function isPc() {
  const agents = [
    "android",
    "iphone",
    "symbianos",
    "windows phone",
    "ipad",
    "ipod",
  ];
  return agents.every((agent) => userAgent.indexOf(agent) < 0);
}

export const isIOS = (() => {
  const isIphone = userAgent.includes("iphone");
  const isIpad = userAgent.includes("ipad");
  return isIphone || isIpad;
})();

export const isWeChat = /MicroMessenger/i.test(userAgent);

export const isWxWork = /wxwork/i.test(userAgent);

export const isPureWeChat = isWeChat && !isWxWork;
